import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router'
import { Table } from 'semantic-ui-react'

import UsersTableHeader from 'Components/UsersTable/UsersTableHeader'

import * as styles from './styles'

import { getFormattedDateString } from 'Global/Helpers/timeHelpers'

const UsersTable = props => {
  const { handleSort, sortBy, sortOrder, users } = props

  const mappedUsers = users.map(user => {
    return (
      <Table.Row key={user.id}>
        <Table.Cell>
          <Link
            to={{
              pathname: `/user/${user.id}`,
              query: { fromPage: 'users' },
            }}
            style={styles.link}
          >
            {user.email}
          </Link>
        </Table.Cell>

        <Table.Cell>{user.firstName}</Table.Cell>

        <Table.Cell>{user.lastName}</Table.Cell>

        <Table.Cell>
          {user.userGroups
            .map(group => group.name)
            .sort((a, b) => a.localeCompare(b))
            .join(', ')}
        </Table.Cell>

        <Table.Cell>{user.lastLogin ? getFormattedDateString(user.lastLogin) : 'Never'}</Table.Cell>
      </Table.Row>
    )
  })

  return (
    <Table columns={5} size="small" fixed selectable sortable>
      <UsersTableHeader handleSort={handleSort} sortBy={sortBy} sortOrder={sortOrder} />

      <Table.Body>{mappedUsers}</Table.Body>
    </Table>
  )
}

UsersTable.propTypes = {
  handleSort: PropTypes.func.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  users: PropTypes.array.isRequired,
}

export default UsersTable
